import { useState } from 'react';
import { Form, Link, useNavigate, useSearchParams } from 'react-router-dom';

import Typography from '@mui/joy/Typography';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import Stack from '@mui/joy/Stack';

import localforage from 'localforage';
import CardLoggedOut from './CardLoggedOut';

import { Success, Error } from './FancyToast';
import { api_post } from 'api/utils';

import useAuth from 'hooks/useAuth';
import { getIcon } from 'utils/misc';
type AuthResponse = {
	auth: {
		token: string;
	}
};

type IDictionary = {
	[key: string]: string;
}


export default function SignInForm() {

    const { currentUser, updateAuthToken, checkingAuth } = useAuth();
    let [searchParams, _] = useSearchParams();


	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
    const [justLoggedIn, setJustLoggedIn] = useState(false);
    const navigate = useNavigate();
    const LoadingIcon = getIcon('Replay');
    // const LabelImportant = getIcon('LabelImportant');

    if(currentUser?.key) {
        console.error("we shouldn't be here!? already logged in");
    }

    function handleSigninSuccess(response : AuthResponse) {
        const auth = response.auth;

        // let's start fresh
		localforage.clear();

        if(updateAuthToken) {
            updateAuthToken(auth.token).then(() => {
                Success("Great! Let's get to it.");
                const url = searchParams.get("redirect") || "/";
                // I can't get authcontext to update, so we'll just redirect
                // like this for now
                setTimeout(() => {
                    window.location.href = url;
                }, 1000);
                // navigate("/");
            });
        }
        else {
            Error("Bad issue with logging in. Not your fault.");
        }
    }

	function handleSigninFailure() {
		localforage.clear();
	}

	function trySignIn() {

		if(!email.trim() || !password.trim()) {
            return Error("Forgetting something?");
		}

		const body = { email: email, password: password } as IDictionary;
		api_post("/password/sign-in", body).then((resp) => {
			if(resp.ok) {
                setJustLoggedIn(true);
				resp.json().then(handleSigninSuccess);
			}
			else if (resp.status === 429) {
                console.log("Error", resp);
				Error("Too many attempts. Try again in 5 seconds.");
				handleSigninFailure();
			}
            else {
				Error("Invalid email or password");
				handleSigninFailure();

        }
		}).catch((err) => {
            console.log("Error", err);
            Error("Issue logging in")
			handleSigninFailure();
		});
	}


	return (
        <CardLoggedOut>
            <Divider />

            <Stack justifyContent="center" alignItems="center">

            { checkingAuth &&
                <Typography
                    endDecorator={<LoadingIcon />}
                    level="body-sm"
                >
                    Checking your credentials...</Typography>
            }
            </Stack>

            { !checkingAuth &&
			<Stack>
				<Typography  component="h1">
					<b>Welcome!</b>
				</Typography>
				<Typography >Everything is better now.</Typography>
			</Stack> }

            { !checkingAuth && !currentUser.key &&
			<Form onSubmit={(e) => { e.preventDefault(); trySignIn() }}>
				<FormControl>
					<FormLabel>Email</FormLabel>
					<Input
						// html input attribute
						value={email}
						onChange={e => setEmail(e.target.value)}
						name="email"
						type="email"
						placeholder="your@email.com"
					/>
				</FormControl>
				<FormControl>
					<FormLabel>Password</FormLabel>
					<Input
						// html input attribute
						onChange={e => setPassword(e.target.value)}
						value={password}
						name="password"
						type="password"
						placeholder="p4ssw0rd"
					/>
				</FormControl>

                <Stack sx={{ ml: "auto", mt: 3, mb: 2 }}>

                <Button type="submit"  sx={{  mt: 1 /* margin top */ }}>Log in</Button></Stack>
			</Form>
            }

            { !checkingAuth && currentUser.key && !justLoggedIn &&
                <Stack my={2} spacing={2}>
                    <Typography level="title-md">You're already logged in.</Typography>
                    <Stack direction="row" justifyContent="center">
                        <Button
                            onClick={() => navigate('/')}
                        >
                        Go to the home page</Button>
                    </Stack>
                </Stack>
            }

            { !checkingAuth && currentUser.key && justLoggedIn &&
                <Stack my={2} spacing={2}>
                    <Stack direction="row" justifyContent="center">
                        <Typography
                            endDecorator={<LoadingIcon
                                sx={{
                                    animation: "backspin 1.4s linear infinite"
                                }}
                            />}
                            color="success"
                            level="body-sm">
                            Success! Loading your account...
                    </Typography>
                    </Stack>
                </Stack>
            }


            <Divider />
            <Stack spacing={0.5}>
                <Typography
                    endDecorator={<Link to="/password/change">Reset It.</Link>}
                    fontSize="sm"
                    sx={{ alignSelf: 'center' }}
                >Time for a new password?
                </Typography>
            </Stack>


		</CardLoggedOut>
	);
}
